"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedMark = exports.label = exports.inputFontSizes = exports.input = exports.helper = exports.border = void 0;
var colors = _interopRequireWildcard(require("./colors"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const input = exports.input = {
  size: '1.6rem'
};
const label = exports.label = {
  size: '1.6rem'
};
const helper = exports.helper = {
  size: '1.6rem'
};
const border = exports.border = {
  color: colors.oriGrey[500]
};
const selectedMark = exports.selectedMark = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' style='width: 24px; height: 24px; fill: %2332a58e;'%3E%3Cpath d='M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m12.351-2.144a.5.5 0 1 0-.702-.712l-4.708 4.65-2.13-1.686a.5.5 0 0 0-.621.784l2.825 2.234z'%3E%3C/path%3E%3C/svg%3E")`;
const inputFontSizes = exports.inputFontSizes = {
  input: {
    mobile: input.size
  },
  'input-label': {
    mobile: label.size
  },
  'input-helper': {
    mobile: helper.size
  }
};
//# sourceMappingURL=textInputData.js.map